<template>
    <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y>
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="value"
                :label="label"
                append-icon="mdi-calendar"
                readonly
                :outlined="outlined"
                :dense="dense"
                :hide-details="hideDetails"
                :class="inputClass"
                v-bind="attrs"
                v-on="on"
                @click:append="on.click"
            ></v-text-field>
        </template>
        <v-date-picker
            :value="value"
            locale="ko"
            :day-format="(day) => parseInt(day.slice(-2))"
            :min="min"
            :max="max"
            @input="onInput"
        ></v-date-picker>
    </v-menu>
</template>

<script>
export default {
    name: 'AppDatePicker',
    props: {
        value:      { type: String,  default: '' },
        label:      { type: String,  default: '날짜' },
        outlined:   { type: Boolean, default: true },
        dense:      { type: Boolean, default: false },
        hideDetails:{ type: Boolean, default: true },
        inputClass: { type: String,  default: '' },
        min:        { type: String,  default: undefined },
        max:        { type: String,  default: undefined },
    },
    data: () => ({
        menu: false,
    }),
    methods: {
        onInput(val) {
            this.menu = false;
            this.$emit('input', val);
        },
    },
};
</script>
